/**
 * Used to login with email and password to firebase
 */
export type LoginRequest = {
	email: string;
	password: string;
};

/**
 * This is the response from firebase after login which we need to use to authenticate against the taxpeer backend
 */
export type LoginResponse = {
	token: string;
};

/**
 * This are roles that can be assigned to a user in an organization
 */
export enum OrgaMemberRole {
	MEMBER = "MEMBER",
	ADMIN = "ADMIN",
}

/**
 * This are roles that can be assigned to a user
 */
export enum SystemRole {
	PLATFORM_MANAGER = "PLATFORM_MANAGER",
	USER = "USER",
}

export enum OrganizationRole {
	MEMBER = "MEMBER",
	ADMIN = "ADMIN",
	KORREKTEUR = "KORREKTEUR",
	AUTHOR = "AUTHOR",
	PRUEFUNG = "PRUEFUNG",
}

/**
 * This is the payload of the JWT token
 */
export type JWTPayload = {
	uid: string;
	email: string;
	displayName: string;
	systemRoles: SystemRole[];
	iat: number;
	exp: number;
	emailVerified: boolean;
};

// the usr type is just the jwt payload
export type User = JWTPayload & {};

/**
 * This is the membership of a user in an organization
 */
export type OrgaMembership = {
	organizationId: string;
	orgaRoles: OrgaMemberRole[];
	name?: string; // name of the organization, this is not always available!
};

/**
 * Request type for password change request
 */
export type PasswordChangeRequest = {
	email: string;
};

/**
 * Request type for password change confirmation
 */
export type PasswordChangeConfirm = {
	token: string;
	password: string;
};

/**
 * Response type for token validity check
 */
export type TokenValidityResponse = {
	isValid: boolean;
};

/**
 * This enum is used to represent the possible failures of a password change request.
 */
export enum PasswordChangeRequestFailure {
	USER_NOT_FOUND = "user_not_found",
	LIMIT_REACHED = "limit_reached",
	UNKNOWN_ERROR = "unknown_error",
}

/**
 * Error response type for password change requests
 */
export type PasswordChangeErrorResponse = {
	error: string;
	errorCode: PasswordChangeRequestFailure;
};
